import { axiosInstance } from '@/service/axios';

export interface Conexao {
  bloqueada: string;
  cadastro: string;
  cep: string;
  codconexao: number;
  contrato: string | number | null;
  endereco: string;
  esta_reduzida: string;
  motivo_bloqueio: string | null;
}

export interface ConexoesResponse {
  result: boolean;
  status: number;
  error: string;
  Conexoes: Conexao[];
}

export async function getConexoes(): Promise<ConexoesResponse> {
  const { data } = await axiosInstance.get<ConexoesResponse>('/conexoes/');
  return {
    result: data?.result !== false,
    status: data?.status ?? 200,
    error: data?.error ?? '',
    Conexoes: Array.isArray(data?.Conexoes) ? data.Conexoes : [],
  };
}
